





























import { Vue, Component, Prop } from 'vue-property-decorator'
import EditForm from '@/components/EditForm.vue'

const fields = 'id firmware installDate license'

@Component({ components: { EditForm }})
export default class InstallForm extends Vue {

	@Prop() install

	defaultInstall = {
		id: '',
		firmware: '',
		installDate: '',
		license: ''
	}

	createInstall = `mutation CreateInstall($input: InstallInput!) {
		createInstall(input: $input) { ${ fields } }
	}`
	updateInstall = `mutation UpdateInstall($input: InstallInput!) {
		updateInstall(input: $input) { ${ fields } }
	}`
	deleteInstall = `mutation DeleteInstall($id: ID!) {
		deleteInstall(id: $id) { ${ fields } }
	}`

}
